export default [
  {
    "name-uz": "Magistratura",
    "name-ru": "Магистратура",
    "name-en": "Master's degree",
    id: "MASTER",
  },
  {
    "name-uz": "Abituriyent",
    "name-ru": "Абитуриент",
    "name-en": "Applicant",
    id: "ABITURIYENT",
  },
  {
    "name-uz": "O`qishni ko`chirish",
    "name-ru": "Perevod",
    "name-en": "Transfer study",
    id: "PEREVOD",
  },
  {
    "name-uz": "Ikkinchi mutaxassislik",
    "name-ru": "Ikkinchi mutaxassislik",
    "name-en": "Second spes",
    id: "SECOND_SPES",
  },
];
